import React from 'react';

export default function Atmosphere() {
  return (
    <section className="atmosphere" id="atmosphere">
      <h2>Наша незабутня атмосфера офлайн зустрічей</h2>
      <p className="atmosphere-subtitle">Щоб відчути ці емоції, тобі точно варто один раз завітати на офлайн зустріч і ти захочеш лишитися з нами назавжди</p>
      <div className="video-container" data-aos="zoom-in">
        <iframe
          src="https://www.youtube.com/embed/T1t9EG1BTmA"
          title="Атмосфера офлайн зустрічей"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
}